(function () {

    'use strict';

    var AdvanceSearchService = ['Atto', 'Principal', 'User', 'toastr', '$rootScope',
        function (Atto, Principal, User, toastr, $rootScope) {
            var service = this;
            var searchParams;

            service.isAdvanceSearchOpen = false;
            
            service.setOpen = function() {
                service.isAdvanceSearchOpen = true;
                $rootScope.$broadcast('advancedSearchOpened');
            };

            service.setClosed = function() {
                service.isAdvanceSearchOpen = false;
                $rootScope.$broadcast('advancedSearchClosed');
            };

            service.isOpen = function() {
                return service.isAdvanceSearchOpen;
            };

            service.saveLatestSearchParams  = function(searchParams) {
                service.searchParams = searchParams;
            };

            service.getLatestSearchParams = function() {
                return service.searchParams;
            };
        }];

    angular.module('gestioneAttiApp').service('AdvanceSearchService', AdvanceSearchService);

})();
